// react
import React, { useEffect, useState, useMemo } from "react";

// third-party
import { Helmet } from "react-helmet-async";

// application
import { getBestSalesProducts, getProductCategories, getProductList } from "../../api/product";

// blocks
import BlockSlideShow from "../blocks/BlockSlideShow";
import { getAnnouncement, getSEOSettings } from "../../api/general";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import BlockAnnouncementCarousel from "../blocks/BlockAnnouncementCarousel";
import moment from "moment";
import Cookies from "universal-cookie";
import BlockLoader from "../blocks/BlockLoader";
import BlockProductsCarousel from "../blocks/BlockProductsCarousel";
import { Link } from "react-router-dom";
import FAQ from "./FAQ";
import { getEventPages, getPages } from "../../api/page";
import BlockPosts from "../blocks/BlockPosts";
import WYSWYG from "../shared/Wyswyg";
import BlockEventPageSlider from "../blocks/BlockEventPageSlider";
import { getEvents } from "../../api/event";
import BlockEventSlider from "../blocks/BlockEventSlider";
import { url } from "../../services/utils";
import BlockTrendingProducts from "../blocks/BlockTrendingProducts";
import { eventTypeList } from "../../data/generalData";

const awardsList = [
    "/images/awards/awards-1-v2.png",
    "/images/awards/awards-2-v2.png",
    "/images/awards/awards-3.png",
    "/images/awards/awards-4-v2.png",
    "/images/awards/awards-5-v2.png",
    "/images/awards/awards-6.png",
    "/images/awards/awards-7.png",
];
function HomePage(props) {
    const { homeSectionCMS, finishLoad, announcements } = props;
    const [modalShow, setModalShow] = useState(false);
    const cookies = new Cookies();
    const [loading, setLoading] = useState(true);
    const [banners, setBanners] = useState([]);
    const [trendingCategories, setTrendingCategories] = useState([]);
    const [cmsSectionList, setCmsSectionList] = useState([]);
    const [latestProducts, setLatestProducts] = useState([]);
    const [latestProductsLoading, setLatestProductsLoading] = useState(true);
    const [shockingSales, setShockingSales] = useState([]);
    const [trendingProducts, setTrendingProducts] = useState([]);
    const [bestSalesProd, setBestSalesProd] = useState([]);
    const [bestSalesProdLoading, setBestSalesProdLoading] = useState(true);
    const [events, setEvents] = useState([]);
    const [eventPages, setEventPages] = useState([]);
    const [blogList, setBlogList] = useState([]);

    useEffect(() => {
        if (announcements?.length) setPopUp(announcements);
    }, [announcements]);

    useEffect(() => {
        getProductList({ per_page: 6, page: 1 }).then((res) => {
            if (res.data && res.data.data) {
                setLatestProducts(res.data);
                setLatestProductsLoading(false);
            }
        });
        getBestSalesProducts().then((res) => {
            if (res.data) {
                setBestSalesProd(res.data);
                setBestSalesProdLoading(false);
            }
        });
        getEventPages({ pgs: "og" }).then((res) => {
            setEventPages(res.data.data);
        });
        getEvents({ pgs: "og" }).then((res) => {
            setEvents(res.data.data);
        });
        getPages({ type: 1, page: 1, per_page: 3 }).then((res) => {
            if (res.data && res.data.data) {
                setBlogList(res.data.data);
            }
        });

        // let params = {
        //     pgs: "og",
        //     type: eventTypeList.find((item) => item.name == "Shocking Sales").code,
        // };
        // if (process.env.REACT_APP_LIST_ADD_CART === "true") params.appends = "variant_info";

        // getEvents(params).then((res) => {
        //     setShockingSales(res.data?.data);
        // });
    }, []);

    // home section cms from system setting api, set each section
    useEffect(() => {
        let trendingCats = homeSectionCMS?.second;
        let cmsSection = homeSectionCMS?.forth;
        let trendingProds = homeSectionCMS?.fifth;

        if (homeSectionCMS?.first) setBanners(homeSectionCMS?.first);

        if (trendingCats && trendingCats.length > 0) {
            let categoriesSlug = [];
            trendingCats.forEach((item) => {
                categoriesSlug.push(item.cat_slug);
            });
            getProductCategories({
                page: 1,
                per_page: 20,
                appends: "image",
                slug: categoriesSlug,
            }).then((res) => {
                if (res.data && res.data.data) {
                    setTrendingCategories(res.data.data);
                    setLoading(false);
                }
            });
        }

        if (trendingProds) {
            let prodSlug = [];
            trendingProds.forEach((item) => {
                prodSlug.push(item.cat_slug);
            });
            setTimeout(() => {
                getProductList({ per_page: 10, page: 1, slug: prodSlug }).then((res) => {
                    if (res.data && res.data.data) {
                        setTrendingProducts(res.data.data);
                    }
                });
            }, 1000);
        }

        if (cmsSection) {
            let pageSlugList = [];
            cmsSection.forEach((item) => {
                pageSlugList.push(item.slug);
            });

            getPages({ include_slug_list: pageSlugList, appends: "content" }).then((res) => {
                if (res.data && res.data.data) {
                    setCmsSectionList(res.data.data);
                }
            });
        }
    }, [homeSectionCMS]);

    function setPopUp(announcement) {
        let previousAnnoucement = cookies.get("announcement_pop_up");
        if (previousAnnoucement == undefined || previousAnnoucement < announcement.length) {
            setModalShow(true);
        }
        cookies.set("announcement_pop_up", announcement?.length, {
            path: "/",
            expires: moment().add(1, "days").utc()._d,
        });
    }

    function renderAnnouncementModal(props) {
        return (
            <Modal size="lg" isOpen={modalShow} toggle={() => setModalShow(false)} centered>
                <ModalHeader toggle={() => setModalShow(false)}></ModalHeader>
                <ModalBody>
                    <BlockAnnouncementCarousel announcements={announcements} />
                </ModalBody>
            </Modal>
        );
    }

    return (
        <React.Fragment>
            <Helmet>
                <title>{`${getSEOSettings("meta_title")}`}</title>
            </Helmet>
            {announcements && announcements[0] ? renderAnnouncementModal() : null}

            {useMemo(
                () => (
                    <BlockSlideShow banners={banners} isFullWidth={true} />
                ),
                [banners]
            )}

            {eventPages?.length > 0 ? <BlockEventPageSlider events={eventPages ? eventPages : []} /> : null}

            {events?.length > 0 ? <BlockEventSlider events={events ? events : []} /> : null}

            {shockingSales.map((sales) => {
                return (
                    sales.event_info?.joined_product_json?.length > 0 && (
                        <BlockTrendingProducts
                            products={sales.event_info?.joined_product_json}
                            mode="carousel"
                            title="SALE"
                            highlightTitle="SHOCKING"
                            countDownDate={sales.end_datetime}
                        />
                    )
                );
            })}

            <div className="home-section1 container">
                <div className="gold-title">About Us</div>
                <div className="content">
                    <p>
                        Most air fragrance found in the market today are created with certain chemical compounds that have a documented
                        adverse effects to health.
                        <br />
                        These are synthetic chemicals that can stay suspended in the air in your car or home for a long time.
                    </p>
                    <p>
                        Some of the more familiar compounds that may be present in our daily lives are: benzene, ethylene glycol,
                        fomaldehyde, methylene chloride, toluene, xylene.
                    </p>
                    <p>
                        That is why it's best that you choose an air fragrance wisely. At Vanzo, our air fragrance are "mainly" made of plant
                        extracts and contains zero alcohol, formaldehyde, benzene, and toluene. They're designed to be safe to enjoy, without
                        smelling overpowering.
                    </p>
                </div>

                <Link to="/about-us" className="btn round-btn">
                    Discover more
                </Link>
            </div>

            <div className="home-section2">
                <div className="bg-img" style={{ backgroundImage: "url('/images/web-images/Pattern.jpg')" }}>
                    <div className="container content-wrapper">
                        <div className="gold-title small p-2">Awards & Certification Won</div>
                        <div className="awards-list p-2">
                            {awardsList.map((imgLink, index) => {
                                return (
                                    <div key={index} className="logo-box">
                                        <img src={imgLink} alt={"awards-" + index} />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <div className="white-space-title">
                <h3 className="mb-0">Latest Products</h3>
            </div>
            <div className="banner-with-text">
            <img
                    className="img-fluid full-width-banner w-100"
                    alt="vanzo_hotel-insprired_series_1"
                    src={"/images/web-images/vanzo_hotel-insprired_series_1.jpg"}
                />
                <div className="left text-content">
                    <div className="title">VANZO NEGATIVE ION AROMA DIFFUSER</div>
                </div>
            </div>
            <div className="banner-with-btn row no-gutters block">
                <img
                    className="img-fluid col-6"
                    alt="vanzo_hotel-insprired_series_2"
                    src={"/images/web-images/vanzo_hotel-insprired_series_2.jpg"}
                />
                <img
                    className="img-fluid col-6"
                    alt="vanzo_hotel-insprired_series_3"
                    src={"/images/web-images/vanzo_hotel-insprired_series_3.jpg"}
                />
                <div className="bottom-content">
                    <p>
                        {
                            "Releases 30 million negative ions, combined with the first [Hotel Series] essential oil, let you enjoy the ambience of a luxe hotel in 1 second."
                        }
                    </p>
                    <Link to={"/vanzo-negative-ion-aroma-diffuser-essential-oil"} className="btn btn-primary">
                        Shop Now
                    </Link>
                </div>
            </div>

            <div className="banner-with-text">
                <img
                    className="img-fluid full-width-banner"
                    alt="vanzo_gentleman_series_1"
                    src={"/images/web-images/vanzo_gentleman_series_1.jpg"}
                />
                <div className="right text-content">
                    <div className="title">Vanzo Gentleman Series</div>
                    <p>A new generation of air fragrance.</p>
                </div>
            </div>
            <div className="banner-with-btn row no-gutters block">
                <img className="img-fluid col-6" alt="vanzo_gentleman_series_2" src={"/images/web-images/vanzo_gentleman_series_2.jpg"} />
                <img className="img-fluid col-6" alt="vanzo_gentleman_series_3" src={"/images/web-images/vanzo_gentleman_series_3.jpg"} />
                <div className="bottom-content">
                    <Link to={"/vanzo-gentleman-goddess-series"} className="btn btn-primary">
                        Shop Now
                    </Link>
                </div>
            </div>

            {latestProducts.data?.length > 0 ? (
                <div className="container">
                    <BlockProductsCarousel
                        // title="New Arrivals"
                        layout="grid-2"
                        type={"highlight"}
                        products={latestProducts.data}
                        loading={latestProductsLoading}
                    />
                </div>
            ) : null}

            <div className="banner-with-text">
                <img className="img-fluid full-width-banner" alt="vanzo_duo_series_1" src={"/images/web-images/vanzo_duo_series_1.jpg"} />
                <div className="right text-content">
                    <div className="title">{"Vanzo\nDuo\nSeries"}</div>
                </div>
            </div>
            <div className="banner-with-btn row no-gutters block">
                <img className="img-fluid col-6" alt="vanzo_duo_series_2" src={"/images/web-images/vanzo_duo_series_2.jpg?v=2"} />
                <img className="img-fluid col-6" alt="vanzo_duo_series_2" src={"/images/web-images/vanzo_duo_series_3.jpg"} />
                <div className="bottom-content">
                    <p>{"A new generation of air \nfragrance."}</p>
                    <Link to={"/vanzo-duo-series-xi-l"} className="btn btn-primary">
                        Shop Now
                    </Link>
                </div>
            </div>

            <div className="banner-with-text pt-5">
                <img
                    className="img-fluid full-width-banner"
                    alt="vanzo_lx_dashboard_1"
                    src={"/images/web-images/vanzo_lx_dashboard_1.jpg"}
                />
                <div className="left text-content">
                    <div className="title">Vanzo LX Dashboard Series</div>
                </div>
            </div>
            <div className="banner-with-btn row no-gutters block">
                <img className="img-fluid col-6" alt="vanzo_lx_dashboard_2" src={"/images/web-images/vanzo_lx_dashboard_2.jpg"} />
                <img className="img-fluid col-6" alt="vanzo_lx_dashboard_3" src={"/images/web-images/vanzo_lx_dashboard_3.jpg"} />
                <div className="bottom-content">
                    <p>{"A new generation of air \nfragrance."}</p>
                    <Link to={"/vanzo-lx-dashboard"} className="btn btn-primary">
                        Shop Now
                    </Link>
                </div>
            </div>

            {bestSalesProd?.length > 0 ? (
                <div className="container">
                    <h4 className="container decorated">
                        <span>Best Seller</span>
                    </h4>

                    <BlockProductsCarousel
                        // title="New Arrivals"
                        layout="grid-4"
                        products={bestSalesProd}
                        loading={bestSalesProdLoading}
                    />
                </div>
            ) : null}

            <div className="home-section4 block">
                <div className="bg-img" style={{ backgroundImage: "url('/images/web-images/why_we_made_these_refreshners.jpg')" }}>
                    <div className="container content-wrapper">
                        <div className="title">Why We Made These fragrance</div>
                        <div>
                            <p>
                                Many air fragrance on the market were either overpowering or do not last as long as we want them to. So, we
                                saw an opportunity to create something different, something better.
                            </p>
                            <p>
                                Vanzo's air fragrance are mainly made with plant-based ingredients, so you won't feel like you're inhaling
                                chemicals. We've also made them last longer than most air fragrance, so you can enjoy them without having
                                to replace so often.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-4">
                <FAQ />
            </div>

            {cmsSectionList.map((item, index) => {
                return (
                    <div key={index} className="container wyswyg-section">
                        <WYSWYG page={item} layout="section" />
                    </div>
                );
            })}

            {useMemo(
                () => (
                    <BlockPosts title="Latest Blogs" layout="grid-nl" posts={blogList} />
                ),
                [blogList]
            )}
        </React.Fragment>
    );
}

export default HomePage;
